/* eslint-disable eqeqeq,no-param-reassign,@typescript-eslint/no-unused-vars */

import { shareReplay } from 'rxjs/operators';
import { DESIGNER_EVENTS } from '../../../app/constants/designer_events';

xplenty.directive('packageVersionForm', [
  '$rootScope',
  '$state',
  '$stateParams',
  '$translate',
  '$timeout',
  'modalService',
  'notify',
  'Designer',

  'Package',

  function (
    $rootScope,
    $state,
    $stateParams,
    $translate,
    $timeout,
    modalService,
    notify,
    Designer,

    Package,
  ) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/forms/package-version-form.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          const getStep = function () {
            return {
              title: '',
              activeTitle: '',
              tags: [],
              active: true,
              valid: false,
              lock: false,
              disable: false,
              useLatest: true,
            };
          };

          $scope.onPackageVersionChange = (packageVersionItem) => {
            if (!packageVersionItem) {
              return;
            }
            $scope.versionObject = packageVersionItem;
          };

          $scope.packageVersionStep = getStep();

          $translate([
            'package-version-form.steps.package',
            'package-version-form.steps.package-edit',
            'package.generic-list.item.actions.rollback',
          ]).then(function (t) {
            $scope.packageVersionStep.title = t['package-version-form.steps.package'];
            $scope.packageVersionStep.activeTitle = t['package-version-form.steps.package-edit'];
          });

          // To disable submit form button if there isn't selected target version of a package
          $scope.$watch('versionObject', function (newVal, oldVal, scope) {
            scope.packageVersionForm.$invalid = !newVal;
          });

          if ($scope.package.version != 0) {
            $scope.rollback = function () {
              const observableCall = Package.rollback(
                $stateParams.id,
                $scope.versionObject && $scope.versionObject.version,
                {
                  account_id: $stateParams.account_id,
                  id: $stateParams.id,
                  version: $scope.versionObject && $scope.versionObject.version,
                  include: 'flow',
                },
                { include: 'flow' },
              ).pipe(shareReplay(1));

              observableCall.subscribe(
                function (res) {
                  if ($state.current.url === '/versions') {
                    $state.reload();
                  } else {
                    $rootScope.$broadcast(DESIGNER_EVENTS.PACKAGE_UPDATE_DATA, res);
                  }
                  modalService.hideModal();
                  notify.success(null, 'The rollback has been performed successfully');
                },
                function () {
                  notify.error(null, $translate.instant('response.422.message'));
                },
              );
              return observableCall;
            };
          } else {
            $timeout(function () {
              $scope.packageVersionForm.$invalid = true;
            });
          }
        },
      ],
    };
  },
]);
